<template>
  <div id="adminContainer">
    <Header v-if="!insideIframe" />
    <CardsList />
    <br><br><br><br>
    <Footer v-if="!insideIframe" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import CardsList from '@/components/board/CardsList'

export default {
  name: 'Admin',
  computed: {
    insideIframe () {
      return this.$store.state.auth.insideIframe
    }
  },
  mounted () {
    axios.defaults.headers.common['Authorization'] =
      'Bearer ' + this.$store.state.auth.token
  },
  components: {
    Header,
    Footer,
    CardsList
  }
}
</script>

<style scoped>
#adminContainer {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: #e6ecf0;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue